var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filledoutline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m456 80v408h-416v-408l208-48z",
    fill: "#0093b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 168h288v320h-288z",
    fill: "#e3e4e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456 80v34.67l-208-50.21-208 50.21v-34.67l208-48z",
    fill: "#0884a9"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#57c3c1",
    height: 32,
    rx: 16,
    transform: "matrix(-1 0 0 -1 496 224)",
    width: 64,
    x: 216,
    y: 96
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480 72-232-56-232 56v32l232-56 232 56z",
    fill: "#e3e4e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 168h288v136h-288z",
    fill: "#c9c9c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 488v-128h-144v-128h-144v256z",
    fill: "#f8bc1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 360h48v48h-48z",
    fill: "#f9da62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 368h-12a12 12 0 0 0 -12 12v20.305a63.7 63.7 0 0 1 -63.695 63.695h-36.305a12 12 0 0 0 -12 12v12h136z",
    fill: "#f5a922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 360h48v48h-48z",
    fill: "#f9da62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 368h-12a12 12 0 0 0 -12 12v20.305a63.7 63.7 0 0 1 -63.695 63.695h-36.305a12 12 0 0 0 -12 12v12h136z",
    fill: "#f5a922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 232h48v48h-48z",
    fill: "#f9da62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 240h-12a12 12 0 0 0 -12 12v20.305a63.7 63.7 0 0 1 -63.695 63.695h-36.305a12 12 0 0 0 -12 12v12h136z",
    fill: "#f5a922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 448h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 352h-136v-120a8 8 0 0 0 -8-8h-144a8 8 0 0 0 -8 8v256a8 8 0 0 0 8 8h288a8 8 0 0 0 8-8v-128a8 8 0 0 0 -8-8zm-88 16h32v32h-32zm-144-128h32v32h-32zm-48 0h32v40a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-40h32v112h-128zm48 128h32v32h-32zm-48 0h32v40a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-40h32v112h-128zm272 112h-128v-112h32v40a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-40h32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264 448h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 320h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.123 111.776a7.941 7.941 0 0 0 1.877.224 8.023 8.023 0 0 0 6.926-3.984 8.237 8.237 0 0 0 1.074-4.2v-31.816a8 8 0 0 0 -6.123-7.776l-232-56a7.967 7.967 0 0 0 -3.754 0l-232 56a8 8 0 0 0 -6.123 7.776v31.773a8.322 8.322 0 0 0 1.374 4.718 8.013 8.013 0 0 0 8.5 3.285l14.126-3.409v99.633h16v-103.495l200-48.276 200 48.276v375.495h-48v-312a8 8 0 0 0 -8-8h-288a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h280v16h-200v16h200v16h-200v16h200v16h-200v16h200v176h-56v16h160v-16h-24v-371.633zm-366.123 80.224v-16h272v16zm136-152a7.943 7.943 0 0 0 -1.877.224l-222.123 53.615v-15.539l224-54.07 224 54.07v15.54l-222.123-53.616a7.943 7.943 0 0 0 -1.877-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264 136a24 24 0 0 0 0-48h-32a24 24 0 0 0 0 48zm-40-24a8.009 8.009 0 0 1 8-8h32a8 8 0 0 1 0 16h-32a8.009 8.009 0 0 1 -8-8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.b58d14532b8e20caa366c0559da4ce18.svg";
export { ForwardRef as ReactComponent };